/**
 * Data portfolio / dokumentasi pekerjaan (structured content).
 *
 * PENTING: Gambar di bawah adalah PLACEHOLDER yang dapat diganti.
 * Untuk mengganti dengan foto asli CV Angkasa Briliant:
 *   1. Simpan foto ke /app/frontend/public/portfolio/ (atau URL hosting Anda)
 *   2. Ubah nilai `image` menjadi path/URL foto asli
 *   3. `isPlaceholder: true` menandakan gambar masih placeholder (muncul label editable)
 */
export const portfolioItems = [
  {
    id: "ac-cleaning",
    title: "AC Cleaning",
    category: "Pembersihan Unit",
    image:
      "https://images.pexels.com/photos/5463580/pexels-photo-5463580.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Dokumentasi pembersihan unit AC oleh teknisi",
    placeholderLabel: "[UPLOAD FOTO AC CLEANING]",
    isPlaceholder: true,
  },
  {
    id: "indoor-unit",
    title: "Indoor Unit",
    category: "AC Split",
    image:
      "https://images.unsplash.com/photo-1762341123870-d706f257a12e?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
    alt: "Dokumentasi unit indoor AC",
    placeholderLabel: "[UPLOAD FOTO INDOOR UNIT]",
    isPlaceholder: true,
  },
  {
    id: "outdoor-unit",
    title: "Outdoor Unit",
    category: "Maintenance",
    image:
      "https://images.pexels.com/photos/6471913/pexels-photo-6471913.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Dokumentasi perawatan unit outdoor AC",
    placeholderLabel: "[UPLOAD FOTO OUTDOOR UNIT]",
    isPlaceholder: true,
  },
  {
    id: "hvac",
    title: "HVAC System",
    category: "Fasilitas Komersial",
    image:
      "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
    alt: "Dokumentasi sistem HVAC pada fasilitas komersial",
    placeholderLabel: "[UPLOAD FOTO HVAC]",
    isPlaceholder: true,
  },
  {
    id: "technician-inspection",
    title: "Inspeksi Teknisi",
    category: "Assessment",
    image:
      "https://images.pexels.com/photos/7347538/pexels-photo-7347538.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Dokumentasi inspeksi teknisi pada unit AC",
    placeholderLabel: "[UPLOAD FOTO INSPEKSI TEKNISI]",
    isPlaceholder: true,
  },
  {
    id: "preventive-maintenance",
    title: "Preventive Maintenance",
    category: "Perawatan Berkala",
    image:
      "https://images.unsplash.com/photo-1705579605238-24a90c8799c5?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
    alt: "Dokumentasi preventive maintenance rooftop HVAC",
    placeholderLabel: "[UPLOAD FOTO PREVENTIVE MAINTENANCE]",
    isPlaceholder: true,
  },
  {
    id: "ac-standing",
    title: "AC Standing / Cassette",
    category: "Unit Komersial",
    image:
      "https://images.unsplash.com/photo-1759772238012-9d5ad59ae637?crop=entropy&cs=srgb&fm=jpg&w=940&q=80",
    alt: "Dokumentasi AC standing dan cassette komersial",
    placeholderLabel: "[UPLOAD FOTO AC STANDING/CASSETTE]",
    isPlaceholder: true,
  },
  {
    id: "before-after",
    title: "Before / After",
    category: "Dokumentasi",
    image:
      "https://images.pexels.com/photos/38788452/pexels-photo-38788452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Dokumentasi kondisi unit sebelum dan sesudah maintenance",
    placeholderLabel: "[UPLOAD FOTO BEFORE/AFTER]",
    isPlaceholder: true,
  },
];

export default portfolioItems;
